var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinearScale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33366 13.3333C1.8609 13.3333 0.666992 12.1394 0.666992 10.6667C0.666992 9.19391 1.8609 8 3.33366 8C4.63552 8 5.71949 8.9329 5.95353 10.1667H15.7138C15.9478 8.9329 17.0318 8 18.3337 8C19.8064 8 21.0003 9.19391 21.0003 10.6667C21.0003 12.1394 19.8064 13.3333 18.3337 13.3333C17.0318 13.3333 15.9478 12.4004 15.7138 11.1667H5.95353C5.71949 12.4004 4.63552 13.3333 3.33366 13.3333Z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 10.666C13.334 12.0467 12.2147 13.166 10.834 13.166C9.45327 13.166 8.33398 12.0467 8.33398 10.666C8.33398 9.2853 9.45327 8.16602 10.834 8.16602C12.2147 8.16602 13.334 9.2853 13.334 10.666Z",
    fill: "#475467"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearScale);
export default __webpack_public_path__ + "static/media/linear-scale.3bb6d6733f0ada2d5a87ee8c8ce95cbb.svg";
export { ForwardRef as ReactComponent };